import { PaddingTypes } from '@viveaesthetics/elemy-shared-core'
import { handlePaddingTypes } from '@viveaesthetics/shared'
import styled from 'styled-components'

export const Card = styled.div<{
  $padding?: PaddingTypes
  shadow?: 'ds1' | 'ds7'
  variant?: 'default' | 'secondary'
}>`
  display: block;
  width: 100%;

  background-color: ${({ theme, variant = 'default' }) =>
    variant === 'default'
      ? theme.styleVariables.ColorTokens.cardBgDefault
      : theme.styleVariables.ColorTokens.cardBgSecondary};

  border: 1px solid
    ${({ theme }) => theme.styleVariables.ColorTokens.cardBorderDefault};
  border-radius: ${({ theme }) => theme.styleVariables.Sizes.Radius.radius16};
  ${({ theme, shadow }) =>
    shadow && `box-shadow: ${theme.styleVariables.Shadows[shadow]};`}

  ${({ $padding }) => handlePaddingTypes({ $padding })}
`
